import { render, staticRenderFns } from "./baseDetailDialogWin.vue?vue&type=template&id=511fe705&"
import script from "./baseDetailDialogWin.vue?vue&type=script&lang=js&"
export * from "./baseDetailDialogWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports